import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';

export const rotate = (rotateDegTrueState: number, rotateDegFalseState: number, duration: number) =>
  trigger('rotate', [
    state('true', style({ transform: `rotate(${rotateDegTrueState}deg)` })),
    state('false', style({ transform: `rotate(${rotateDegFalseState}deg)` })),
    transition('0 <=> 1', animate(`${duration}ms ease-out`)),
  ]);

export const translateX = (enterTranslateX: string, leaveTranslateX: string, duration: number) =>
  trigger('translateX', [
    transition(':enter', [
      style({ transform: `translateX(-${enterTranslateX})` }),
      animate(`${duration}ms ease-out`, style({ transform: `translateX(${leaveTranslateX})` })),
    ]),
    transition(':leave', [
      style({ transform: `translateX(${leaveTranslateX})` }),
      animate(`${duration}ms ease-out`, style({ transform: `translateX(-${enterTranslateX})` })),
    ]),
  ]);

export const slideFromRight = (duration: number) =>
  trigger('slideFromRight', [
    transition(':enter', [
      style({ width: '0px', overflow: 'hidden' }),
      animate(`${duration}ms`, style({ width: '*' })),
    ]),
    transition(':leave', [
      style({ width: '*', overflow: 'hidden' }),
      animate(`${duration}ms`, style({ width: '0px' })),
    ]),
  ]);

export const showOrHide = () =>
  trigger('showOrHide', [
    state('true', style({ transform: 'translateX(0)', opacity: 1, display: 'block' })),
    state('false', style({ transform: 'translateX(-100%)', opacity: 0.9, display: 'none' })),
    transition('0 <=> 1', [style({ display: 'block' }), animate('500ms ease-out')]),
  ]);

export const fadeIn = () =>
  trigger('fadeIn', [
    transition(':enter', [
      style({ backgroundColor: 'transparent' }),
      animate('500ms ease-out', style({ backgroundColor: 'rgba(0, 0, 0, 0.5)' })),
    ]),
  ]);

/**
 * Don't forget to add overflow-hidden to the impacted div
 */
export const vSlideInOut = (duration = 500) =>
  trigger('vSlideInOut', [
    transition(':enter', [style({ height: '0px' }), animate(`${duration}ms`, style({ height: '*' }))]),
    transition(':leave', [animate(`${duration}ms`, style({ height: '0px' }))]),
  ]);

export const hSlideIn = (duration = 500) =>
  trigger('hSlideIn', [
    transition(':enter', [
      style({ width: '0px', overflow: 'hidden' }),
      animate(`${duration}ms`, style({ width: '*' })),
      animate(`${duration}ms`, style({ overflow: 'auto' })),
    ]),
  ]);

export const routeAnimations = () =>
  trigger('routeAnimations', [
    transition(':enter, :leave', []),
    transition('* <=> *', [
      style({ position: 'relative' }),
      query(
        ':enter, :leave',
        [
          style({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }),
        ],
        { optional: true }
      ),
      query(':enter', [style({ opacity: 0 })], { optional: true }),
      query(':leave', [style({ zIndex: 10 })], { optional: true }),
      query(':leave', animateChild(), { optional: true }),
      group([
        query(':leave', [animate('300ms ease-out', style({ opacity: 0 }))], { optional: true }),
        query(':enter', [animate('500ms ease-in', style({ opacity: 1 }))], { optional: true }),
        query('@*', animateChild(), { optional: true }),
      ]),
    ]),
  ]);
